import * as R from 'ramda'
import {
  getNameDescriptionTableColumn,
  getEnabledTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn'
import i18n from '@/locales'
import DimensionMixin from './dimension'
// import { getTagColor, getTagTitle } from '@/utils/common/tag'
export default {
  mixins: [DimensionMixin],
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        hideField: true,
        edit: (row) => {
          const { isDomainMode, userInfo } = this.$store.getters
          if (isDomainMode && (userInfo.projectDomainId !== row.domain_id)) {
            return false
          }
          return true
        },
        formRules: [{ required: true, message: i18n.t('bill.text_145') },
          { max: 256, message: i18n.t('validator.maxLength', ['256']) }],
        showDesc: (row) => {
          const { isDomainMode, userInfo } = this.$store.getters
          if (isDomainMode && (userInfo.projectDomainId !== row.domain_id)) {
            return false
          }
          return true
        },
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger>
          )
        },
      }),
      getEnabledTableColumn(),
      {
        field: 'dimension_type',
        title: i18n.t('bill.text_288'),
        slots: {
          default: ({ row }) => {
            const dimensionTypeItem = R.find(R.propEq('value', row.dimension_type))(this.dimensionTypeList)
            return dimensionTypeItem.key || '-'
          },
        },
      },
      {
        field: 'dimension_items',
        title: i18n.t('bill.text_289'),
        type: 'expand',
        slots: {
          default: ({ row }) => {
            return row.dimension_items ? row.dimension_items.length : '-'
          },
          content: ({ row }) => {
            const columns = [
              {
                field: 'name',
                title: i18n.t('bill.text_289'),
              },
              {
                field: 'joint_id',
                title: i18n.t('bill.text_300'),
                slots: {
                  default: ({ row }) => {
                    const dimensionItems = []
                    if (row.dimension_type === 'domain') {
                      row.dimension_domains.map(item => {
                        if (this.domainList.length) {
                          const domainList = this.domainList.filter(domain => {
                            return domain.id === item.domain_id
                          })
                          if (domainList[0]) {
                            dimensionItems.push(<span class="tag mb-1 text-truncate d-inline-block">{this.dimensionTag(domainList[0], 'domain')}</span>)
                          }
                        }
                      })
                    }
                    if (row.dimension_type === 'resource_type') {
                      row.dimensions_analysis.map(item => {
                        dimensionItems.push(<span class="tag mb-1 text-truncate d-inline-block">{this.dimensionTag(item, 'resource_type')}</span>)
                      })
                    }
                    if (row.dimension_type === 'project') {
                      row.dimension_projects.map(item => {
                        if (this.projectList.length) {
                          const projectList = this.projectList.filter(project => {
                            return project.id === item.project_id
                          })
                          if (projectList[0]) {
                            dimensionItems.push(<span class="tag mb-1 text-truncate d-inline-block">{this.dimensionTag(projectList[0], 'project')}</span>)
                          }
                        }
                      })
                    }
                    if (row.dimension_type === 'bill') {
                      row.dimensions_analysis.map(item => {
                        dimensionItems.push(<span class="tag mb-1 text-truncate d-inline-block">{this.dimensionTag(item, 'bill')}</span>)
                      })
                    }
                    return dimensionItems
                  },
                },
              },
            ]
            return <vxe-grid size="mini" border columns={columns} data={row.dimension_items ? row.dimension_items.map(item => {
              return Object.assign(item, { dimension_type: row.dimension_type })
            }) : []} />
          },
        },
      },
      getTimeTableColumn(),
    ]
  },
}
